import { IViewDishContext } from './viewDishContext';

export enum ViewDishActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	REFETCH_REST_PROPS_DATA = 'REFETCH_REST_PROPS_DATA',
	REFETCH_PORTIONS_DATA = 'REFETCH_PORTIONS_DATA',
	SET_DISH_FULL_INFO = 'SET_DISH_FULL_INFO',
	SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS = 'SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS',
	SET_RESTAURANT_PROPS = 'SET_RESTAURANT_PROPS',
	SET_RESTAURANT_ID_FOR_PORTIONS = 'SET_RESTAURANT_ID_FOR_PORTIONS',
	SET_RESTAURANT_PORTIONS = 'SET_RESTAURANT_PORTIONS',
	CHANGE_SELECTED_PORTION_ID = 'CHANGE_SELECTED_PORTION_ID',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: ViewDishActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IViewDishContext['needRefetchData'];
	};
}

interface IRefetchRestPropsData {
	type: ViewDishActionTypes.REFETCH_REST_PROPS_DATA;
	payload: {
		needRefetchRestPropsData: IViewDishContext['needRefetchRestPropsData'];
	};
}

interface IRefetchPortionsData {
	type: ViewDishActionTypes.REFETCH_PORTIONS_DATA;
	payload: {
		needRefetchRestaurantPortionsData: IViewDishContext['needRefetchRestaurantPortionsData'];
	};
}

interface ISetDishFullInfo {
	type: ViewDishActionTypes.SET_DISH_FULL_INFO;
	payload: {
		dishFullInfo: IViewDishContext['dishFullInfo'];
		accessibleRestaurants: IViewDishContext['accessibleRestaurants'];
		accessiblePortionsRestaurants: IViewDishContext['accessiblePortionsRestaurants'];
	};
}

interface ISetRestaurantIdForRestaurantProps {
	type: ViewDishActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS;
	payload: {
		restaurantIdForRestaurantProps: IViewDishContext['restaurantIdForRestaurantProps'];
		restaurantProps: IViewDishContext['restaurantProps'];
	};
}

interface ISetRestaurantProps {
	type: ViewDishActionTypes.SET_RESTAURANT_PROPS;
	payload: {
		restaurantProps: IViewDishContext['restaurantProps'];
	};
}

interface ISetRestaurantIdForPortions {
	type: ViewDishActionTypes.SET_RESTAURANT_ID_FOR_PORTIONS;
	payload: {
		restaurantIdForPortions: IViewDishContext['restaurantIdForPortions'];
		restaurantPortions: IViewDishContext['restaurantPortions'];
	};
}

interface ISetRestaurantPortions {
	type: ViewDishActionTypes.SET_RESTAURANT_PORTIONS;
	payload: {
		restaurantPortions: IViewDishContext['restaurantPortions'];
	};
}

interface IChangeSelectedPortionId {
	type: ViewDishActionTypes.CHANGE_SELECTED_PORTION_ID;
	payload: {
		selectedPortionId: IViewDishContext['selectedPortionId'];
	};
}

interface ISetTranslationTab {
	type: ViewDishActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IViewDishContext['selectedTranslationTab'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ViewDishActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IViewDishContext['typeOfModalWindow'];
	};
}

export type TViewDishAction =
	| IRefetchData
	| IRefetchRestPropsData
	| IRefetchPortionsData
	| ISetDishFullInfo
	| ISetRestaurantIdForRestaurantProps
	| ISetRestaurantProps
	| ISetRestaurantIdForPortions
	| ISetRestaurantPortions
	| IChangeSelectedPortionId
	| ISetTranslationTab
	| IChangeTypeOfModalWindow;
